import { TableCell, TableRow, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { VIEW_DRAFTS } from "../lib/library-views"

export function DraftComponentRow({ item }) {
    const { setSelectedTaskId } = useBoundContext()

    return (
        <TableRow data-cy="draft-component-row" hover sx={{ cursor: "pointer" }} onClick={handleClick}>
            <TableCell>
                <Typography variant="subtitle2" sx={{ overflowWrap: "anywhere" }}>
                    {item.heading}
                </Typography>
            </TableCell>
            <TableCell>
                <TruncatedTypography variant="body2" color="text.secondary">
                    {item.categoryPath || "—"}
                </TruncatedTypography>
            </TableCell>
        </TableRow>
    )

    function handleClick() {
        setSelectedTaskId(item.id, { from: VIEW_DRAFTS })
    }
}
